import { render } from "./shops_list_item.vue?vue&type=template&id=f6a3aa40&scoped=true"
import script from "./shops_list_item.vue?vue&type=script&lang=js"
export * from "./shops_list_item.vue?vue&type=script&lang=js"

import "./shops_list_item.vue?vue&type=style&index=0&id=f6a3aa40&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6a3aa40"]])

export default __exports__